module.exports = __webpack_public_path__ + "static/img/5.496bb97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/5.png
// module id = ydms
// module chunks = 0